import f from "./_Symbol.js";
import y from "./_arrayMap.js";
import a from "./isArray.js";
import s from "./isSymbol.js";
var t = f, p = y, b = a, e = s, S = 1 / 0, i = t ? t.prototype : void 0, n = i ? i.toString : void 0;
function m(r) {
  if (typeof r == "string")
    return r;
  if (b(r))
    return p(r, m) + "";
  if (e(r))
    return n ? n.call(r) : "";
  var o = r + "";
  return o == "0" && 1 / r == -S ? "-0" : o;
}
var l = m;
export {
  l as default
};
//# sourceMappingURL=_baseToString.js.map
